import MojitoCore from 'mojito/core';

import {actions as metaDataActions} from '#core/application/seo/store/slice.js';
import * as MetaDataSelectors from '#core/application/seo/store/selectors.js';
import {wrapExternal} from '#core/application/api/utils.js';

const reduxInstance = MojitoCore.Services.redux;

reduxInstance.actionListener.startListening({
    actionCreator: metaDataActions.setMetaData,
    effect: data => {
        if (metaDataListener) metaDataListener(data.payload);
    },
});

let metaDataListener = null;

export function setMetaDataListener(val) {
    metaDataListener = wrapExternal(val);

    if (metaDataListener) {
        // immediately send the current meta information
        const metaData = MetaDataSelectors.selectMetaData();
        if (metaData) {
            setTimeout(() => {
                metaDataListener(metaData);
            });
        }
    }
}

export function getMetaData() {
    return MetaDataSelectors.selectMetaData();
}
